/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum mfaTypeEnum {
    EMAIL = 'email',
    SMS = 'sms',
    AUTH_APP = 'auth_app',
}